import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet-async";
import {
  Box,
  Button,
  Container,
  Card,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import CustomSnackbar from "../../utils/CustomSnackbar";
import useDetails from "src/hooks/useDetails";
import Image from "../PatientsDasboard/Image";
import { useParams } from "react-router-dom";
import { useLocation } from "react-router-dom";

const ReportIssueEdit = () => {
  const location = useLocation();
  const { id } = location.state || {}; // Extract the ID from the passed state
  const [rows, setRows] = useState([]);
  const [imagePreview, setImagePreview] = useState();
  const navigate = useNavigate();
  const [openSnack, setOpenSnack] = useState({
    open: false,
    severity: null,
    message: null,
  });

  const [formData, setFormData] = useState({
    id: "",
    u_id: "",
    u_role: "",
    issue_priority: "",
    issue_date: "",
    issue_status: "",
    issue_description: "",
    issue_upload: "",
    issue_dev_comment: "",
    issue_resolve_date: "",
  });
  useEffect(() => {
    console.log("Updated formData:", formData);
  }, [formData]);

  // Fetch data from the API
  useEffect(() => {
    // Adjust the URL to fetch the data for the specific 'id'
    fetch(`https://ehr.kaizendigital.ai/api/dev3/getreport/${id}`)
      .then((response) => response.json())
      .then((data) => {
        if (data) {
          setFormData({
            id: data.id || "",
            u_id: data.u_id || "",
            u_role: data.u_role || "",
            issue_priority: data.issue_priority || "",
            issue_date: data.issue_date || "",
            issue_status: data.issue_status || "",
            issue_description: data.issue_description || "",
            issue_upload: data.issue_upload || "",
            issue_dev_comment: data.issue_dev_comment || "",
            issue_resolve_date: data.issue_resolve_date || "",
          });
        }
      })
      .catch((error) => console.error("Error:", error));
  }, [id]);

  // Handle input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = () => {
    const data = new FormData();

    // Append form fields to FormData
    Object.keys(formData).forEach((key) => {
      if (key === "issue_upload" && typeof formData[key] === "object") {
        // Append the file object for issue_upload
        data.append(key, formData[key]);
      } else if (key !== "issue_upload") {
        data.append(key, formData[key]);
      }
    });

    axios
      .post("https://ehr.kaizendigital.ai/api/dev3/updatereport", data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        {
          setOpenSnack({
            open: true,
            severity: "success",
            message: "Details Saved Successfully",
            position: ["bottom", "center"],
          });
          setTimeout(() => {
            navigate("/");
          }, 2000);
        }
      })
      .catch((error) => {
        setOpenSnack({
          open: true,
          severity: "error",
          message: "Something went Wrong",
          position: ["bottom", "center"],
        });
      });
  };

  // Handle file selection for issue_upload
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData({
        ...formData,
        issue_upload: file, // Store the file object in formData
      });
      // Optional: Set image preview
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result); // Preview image
      };
      reader.readAsDataURL(file);
    }
  };
  const { open, severity, message, position } = openSnack;

  return (
    <>
      {CustomSnackbar(open, severity, message, position)}

      <Helmet>
        <title>Edit an Issue | Kaizen Digital</title>
      </Helmet>
      <Typography variant="h3" sx={{ mb: 0 }} color="primary">
        Edit Issue Status
      </Typography>

      <Card maxWidth="md" sx={{ mt: 4 }}>
        <Box m="20px">
          <Grid container spacing={2}>
            <Grid item xs={6} sm={3}>
              <TextField
                fullWidth
                label="User Role"
                name="u_role"
                variant="outlined"
                size="small"
                value={formData.u_role}
                onChange={handleInputChange}
              />
            </Grid>
            <Grid item xs={6} sm={3}>
              <TextField
                fullWidth
                label="Priority"
                name="issue_priority"
                variant="outlined"
                size="small"
                value={formData.issue_priority}
                onChange={handleInputChange}
              />
            </Grid>
            <Grid item xs={6} sm={3}>
              <TextField
                fullWidth
                label="Received Date"
                name="issue_date"
                variant="outlined"
                size="small"
                value={formData.issue_date}
                onChange={handleInputChange}
              />
            </Grid>
            <Grid item xs={6} sm={3}>
              <TextField
                fullWidth
                label="Status"
                name="issue_status"
                variant="outlined"
                size="small"
                value={formData.issue_status}
                onChange={handleInputChange}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Issue Description"
                name="issue_description"
                variant="outlined"
                multiline
                rows={4}
                value={formData.issue_description}
                onChange={handleInputChange}
              />
            </Grid>
            <Grid item xs={12}>
              <Image
                src={`https://ehr.kaizendigital.ai/api/dev3/${formData.issue_upload}`}
                alt="issue_upload"
              />
              {/* <TextField
                fullWidth
                label="Image(s)"
                name="issue_upload"
                variant="outlined"
                size="small"
                value={formData.issue_upload} // Not editable since it's only for display
                onChange={handleInputChange}
                InputProps={{
                  readOnly: true, // Make it read-only to prevent changes
                }}
              /> */}
              {/* {imagePreview && (
                <div style={{ marginTop: "10px" }}>
                  <img
                    src={imagePreview}
                    alt="Uploaded Preview"
                    style={{
                      maxWidth: "100%",
                      maxHeight: "200px",
                      objectFit: "cover",
                    }}
                  />
                </div>
              )} */}
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Developer's Comments"
                name="issue_dev_comment"
                variant="outlined"
                size="small"
                value={formData.issue_dev_comment}
                onChange={handleInputChange}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Resolved Date"
                name="issue_resolve_date"
                variant="outlined"
                size="small"
                value={formData.issue_resolve_date}
                onChange={handleInputChange}
              />
            </Grid>
          </Grid>

          <Box sx={{ mt: 3, display: "flex", justifyContent: "flex-end" }}>
            <Button variant="contained" color="primary" onClick={handleSubmit}>
              Save
            </Button>
          </Box>
        </Box>
      </Card>
    </>
  );
};

export default ReportIssueEdit;
